import { Component, OnDestroy, OnInit } from '@angular/core';
import { GoogleCustomer } from '../../Model/googlecustomer';
import { LocalStorageService } from '../../services/local-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiFactoryEndPoints } from '../../common/api-factory-end-points';
import { Subscription } from 'rxjs';
import { ProductService } from '../../services/product.service';
import { CommonExternalModule } from '../../common/common-external-module';
import { HeaderComponent } from '../../components/header/header.component';
enum PaymentState {
  VERIFYING = 'VERIFYING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  PAYMENT_DONE_ORDER_PENDING = 'PAYMENT_DONE_ORDER_PENDING'
}

@Component({
  selector: 'app-payment-status',
  standalone: true,
  imports: [CommonExternalModule, HeaderComponent],
  templateUrl: './payment-status.component.html',
  styleUrl: './payment-status.component.css'
})
export class PaymentStatusComponent implements OnInit, OnDestroy {

  readonly PaymentState = PaymentState;
  private destroyed = false;
  private pollTimeout: any;

  attempt = 0;
  maxRetries = 6;
  retryDelayMs = 10000; // 10 sec
  totalTimeSeconds = (this.maxRetries * this.retryDelayMs) / 1000;
  remainingSeconds = this.totalTimeSeconds;
  progressPercent = 0;


  state: PaymentState = PaymentState.VERIFYING;

  googleCustomer: GoogleCustomer;

  private pollingSub!: Subscription;
  private cartSetUpSubscription: Subscription;
  private timerInterval: any;

  constructor(
    private localStorage: LocalStorageService,
    private route: ActivatedRoute,
    private apiFactory: ApiFactoryEndPoints,
    private navRoute: Router,
    public productService: ProductService
  ) { }

  ngOnInit(): void {
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    this.route.queryParams.subscribe((data) => {
      if (data) {
        console.log("data", data);
        this.startVerification(data);
      }
    });
  }

  ngOnDestroy() {
    this.destroyed = true;
    this.stopAll();
  }

  startVerification(data: any) {
    if (!data['trans_id']) return;

    const transactionId = data['trans_id'];

    this.startTimer();

    const pollStatus = () => {

      if (this.destroyed) return; // ✅ prevent further calls

      this.attempt++;

      this.pollingSub = this.productService
        .getOrderDetailsByOrderNo(
          this.apiFactory.getExceptionWebOrderByOrderNo,
          transactionId
        )
        .subscribe({
          next: (resp: any) => {

            const webStatus = resp?.hasWebOrderResponse;
            const ccStatus = resp?.hasCCAvenueResponse;

            // ✅ SUCCESS
            if (webStatus === 'Success') {
              this.stopAll();
              this.state = PaymentState.SUCCESS;

              const ids = resp.productCodes?.split(',').map(Number) || [];
              this.removeCartProductsAndRedirect(ids);
              return;
            }

            // ❌ FAILURE
            if (ccStatus === 'Aborted' ||
              ccStatus === 'Failure' ||
              ccStatus === 'Timeout') {

              this.stopAll();
              this.state = PaymentState.FAILED;
              this.navRoute.navigate(['/payment-fail']);
              return;
            }

            // ⏳ RETRY
            if (this.attempt < this.maxRetries) {

              this.pollTimeout = setTimeout(() => {
                if (!this.destroyed) {
                  pollStatus();
                }
              }, this.retryDelayMs);

            } else {
              this.handleFinalState(ccStatus, webStatus);
            }
          },
          error: () => {
            if (this.attempt < this.maxRetries) {

              this.pollTimeout = setTimeout(() => {
                if (!this.destroyed) {
                  pollStatus();
                }
              }, this.retryDelayMs);

            } else {
              this.stopAll();
              this.state = PaymentState.FAILED;
              this.navRoute.navigate(['/payment-fail']);
            }
          }
        });
    };

    pollStatus();
  }

  startTimer() {
    this.remainingSeconds = this.totalTimeSeconds;
    this.progressPercent = 0;

    this.timerInterval = setInterval(() => {
      this.remainingSeconds--;

      this.progressPercent =
        ((this.totalTimeSeconds - this.remainingSeconds) /
          this.totalTimeSeconds) *
        100;

      if (this.remainingSeconds <= 0) {
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  stopTimer() {
    clearInterval(this.timerInterval);
  }

  // ✅ Stop everything safely
  private stopAll() {
    if (this.pollTimeout) {
      clearTimeout(this.pollTimeout);
    }

    if (this.pollingSub) {
      this.pollingSub.unsubscribe();
    }

    this.stopTimer();
  }

  removeCartProductsAndRedirect(data: number[]) {
    if (data.length > 0) {
      this.cartSetUpSubscription = this.productService.emptyProductCart(this.apiFactory.emptyProductCart, this.googleCustomer.email)
        .subscribe((data: any) => {
          console.log(data.Res);
          // window.location.reload();
          this.navRoute.navigate(["/payment-success"], {
            state: { data: "reload" },
          });
        });
    }
  }

  // ✅ Final State Decision After Max Retry
  private handleFinalState(ccStatus: string, webStatus: string) {
    this.stopTimer();
    if (ccStatus === 'Success' && webStatus === 'Failed') {
      this.state = PaymentState.PAYMENT_DONE_ORDER_PENDING;
      return;
    }
    this.state = PaymentState.FAILED;
    this.navRoute.navigate(['/payment-fail']);
  }

  goToHome() {
    this.navRoute.navigate(["/payment-history"]);
  }
}